import { ToastMessages } from "enums";
import { enqueueSnackbar } from "notistack";

export function onFormErrorDefault(): void {
  enqueueSnackbar({
    variant: "error",
    message: ToastMessages.ERROR_FORM_VALIDATION,
  });
}
